import { createI18n } from 'vue-i18n';
import { detectLanguage, getDirectionForLanguage } from './languageDetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

// Detect initial language
const initialLanguage = detectLanguage();

// Set initial direction based on language
const initialDirection = getDirectionForLanguage(initialLanguage);
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('dir', initialDirection);
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: initialLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
    ar
  },
  globalInjection: true, // Enable $t in templates
  missingWarn: false, // Disable warnings for missing translations in dev
  fallbackWarn: false,
  silentTranslationWarn: true, // Suppress translation warnings
  silentFallbackWarn: true, // Suppress fallback warnings
  // Add error handler to prevent crashes from invalid message formats
  warnHtmlMessage: false // Disable HTML message warnings
});


const { t } = i18n.global;

export { t };
export default i18n;
